module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.25a3241.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/theme/assets/common/fonts/fontawesome-webfont.eot
// module id = ./assets/theme/assets/common/fonts/fontawesome-webfont.eot
// module chunks = 152